import { Modal, Row, Col, Form, Button, Spinner } from 'react-bootstrap';
import { useEffect, useState, useRef } from "react";
import { FormInputElement } from '../../Form/FormInputElement';
import { useApiClient } from '../../../ApiService/useApiClient';

const EditClientSection1 = ({ show, setShowAddEdit, data, setdata }) => {

  const api = useApiClient();

  const formDefault = {
    opened: true,
    modalTitle: "Client Details"
  };
  const [formModal, setFormModal] = useState(formDefault);
  const [error, setError] = useState(null);
  const [validated, setValidated] = useState(false);
  const modalForm = useRef(null);

  useEffect(() => {
    // Populate formModal fields whenever `show` or `data` changes
    setFormModal({
      ...formModal,
      opened: show,
      action: 'edit',
      title: data.title,
      Fname: data.firstName,
      Lname: data.lastName,
      dateofbirth: data.dateOfBirth,
      gender: data.gender,
      hns_number: data.hnsNumber,
      TelNo: data.companyTelNo,
      MobileNo: data.mobileNo,
      EmailAddress: data.emailAddress,
      company_add1: data.companyAdd1,
      company_add2: data.companyAdd2,
      company_add3: data.companyAdd3,
      company_add4: data.companyAdd4,
      postcode: data.postcode
    });
    setValidated(false);
  }, [show]);


const isAtLeast18YearsOld = (dobStr) => {
  const dob = new Date(dobStr);
  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const m = today.getMonth() - dob.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
    age--;
  }
  return age >= 18;
};

  function closeFormModal() {
    setFormModal({ ...formModal, opened: false });
    setShowAddEdit(false);
    setValidated(false);
  }

  // function handleFormSubmit(event) {
  //   event.preventDefault();
  //   event.stopPropagation();

  //   const form = modalForm.current;
  //   if (!form.checkValidity()) {
  //     setValidated(true);
  //     return;
  //   }

  //   // All required fields are valid—collect values and submit
  //   const title = form.querySelector('#title').value;
  //   const Fname = form.querySelector('#Fname').value;
  //   const Lname = form.querySelector('#Lname').value;
  //   const EmailAddress = form.querySelector('#EmailAddress').value;
  //   const MobileNo = form.querySelector('#MobileNo').value;
  //   const TelNo = form.querySelector('#TelNo').value;
  //   const hns_number = form.querySelector('#hns_number').value;
  //   const dateofbirth = form.querySelector('#dateofbirth').value;
  //   const gender = form.querySelector('#gender').value;
  //   const company_add1 = form.querySelector('#company_add1').value;
  //   const company_add2 = form.querySelector('#company_add2').value;
  //   const company_add3 = form.querySelector('#company_add3').value;
  //   const company_add4 = form.querySelector('#company_add4').value;
  //   const postcode = form.querySelector('#postcode').value;

  //   const frmFormData = new FormData();
  //   frmFormData.append("CustomerId", data.customerId);
  //   frmFormData.append("Title", title);
  //   frmFormData.append("FirstName", Fname);
  //   frmFormData.append("LastName", Lname);
  //   frmFormData.append("EmailAddress", EmailAddress);
  //   frmFormData.append("MobileNo", MobileNo);
  //   frmFormData.append("CompanyTelNo", TelNo);
  //   frmFormData.append("HnsNumber", hns_number);
  //   frmFormData.append("DateOfBirth", dateofbirth);
  //   frmFormData.append("Gender", gender);
  //   frmFormData.append("CompanyAdd1", company_add1);
  //   frmFormData.append("CompanyAdd2", company_add2);
  //   frmFormData.append("CompanyAdd3", company_add3);
  //   frmFormData.append("CompanyAdd4", company_add4);
  //   frmFormData.append("Postcode", postcode);

  //   const sURL = "HMCareData/customer/modify/";
    
  //   api.post(sURL, frmFormData)
  //     .then((Response) => {
  //       const updatedDataObj = Response.data;
  //       setdata(updatedDataObj);
  //       closeFormModal();
  //     })
  //     .catch(err => {
  //       setError(err);
  //       console.error(err);
  //     });
  // }

  function handleFormSubmit(event) {
  event.preventDefault();
  event.stopPropagation();

  const form = modalForm.current;
  if (!form.checkValidity()) {
    setValidated(true);
    return;
  }

  const dateofbirth = form.querySelector('#dateofbirth').value;

  // ✅ Age validation
  if (!isAtLeast18YearsOld(dateofbirth)) {
    setError("Client must be at least 18 years old.");
    setValidated(true);
    return;
  }

  const title = form.querySelector('#title').value;
  const Fname = form.querySelector('#Fname').value;
  const Lname = form.querySelector('#Lname').value;
  const EmailAddress = form.querySelector('#EmailAddress').value;
  const MobileNo = form.querySelector('#MobileNo').value;
  const TelNo = form.querySelector('#TelNo').value;
  const hns_number = form.querySelector('#hns_number').value;
  const gender = form.querySelector('#gender').value;
  const company_add1 = form.querySelector('#company_add1').value;
  const company_add2 = form.querySelector('#company_add2').value;
  const company_add3 = form.querySelector('#company_add3').value;
  const company_add4 = form.querySelector('#company_add4').value;
  const postcode = form.querySelector('#postcode').value;

  const frmFormData = new FormData();
  frmFormData.append("CustomerId", data.customerId);
  frmFormData.append("Title", title);
  frmFormData.append("FirstName", Fname);
  frmFormData.append("LastName", Lname);
  frmFormData.append("EmailAddress", EmailAddress);
  frmFormData.append("MobileNo", MobileNo);
  frmFormData.append("CompanyTelNo", TelNo);
  frmFormData.append("HnsNumber", hns_number);
  frmFormData.append("DateOfBirth", dateofbirth);
  frmFormData.append("Gender", gender);
  frmFormData.append("CompanyAdd1", company_add1);
  frmFormData.append("CompanyAdd2", company_add2);
  frmFormData.append("CompanyAdd3", company_add3);
  frmFormData.append("CompanyAdd4", company_add4);
  frmFormData.append("Postcode", postcode);

  const sURL = "HMCareData/customer/modify/";

  api.post(sURL, frmFormData)
    .then((Response) => {
      const updatedDataObj = Response.data;
      setdata(updatedDataObj);
      closeFormModal();
    })
    .catch(err => {
      setError(err);
      console.error(err);
    });
}


  return (
    <Modal show={formModal.opened} onHide={closeFormModal} size="lg" backdrop="static">
      <Form 
        ref={modalForm} 
        noValidate 
        validated={validated} 
        onSubmit={handleFormSubmit}
      >
        <Modal.Header closeButton>
          <Modal.Title className="event-title" as="h4">
            {formModal.modalTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="g-gs">
            <Col xs="2">
              <Form.Group controlId="title">
                <Form.Label>Title</Form.Label>
                <Form.Select
                  id="title"
                  value={formModal.title || ""}
                  onChange={e => setFormModal({ ...formModal, title: e.target.value })}
                  required
                >
                  <option value="">Choose...</option>
                  <option value="Mr">Mr</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Ms">Ms</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  Please select a title.
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <FormInputElement
              type="text"
              id="Fname"
              ColWidth={4}
              maxLength={100}
              Label="First Name"
              defaultValue={formModal.Fname || ""}
              placeholder="First Name(s)"
              required={true}
            />

            <FormInputElement
              type="text"
              id="Lname"
              ColWidth={6}
              maxLength={150}
              Label="Last Name"
              defaultValue={formModal.Lname || ""}
              placeholder="Last Name"
              required={true}
            />

            <FormInputElement
              type="email"
              id="EmailAddress"
              ColWidth={6}
              maxLength={100}
              Label="Email Address"
              defaultValue={formModal.EmailAddress || ""}
              placeholder="Email Address"
              required={true}
            />

            <FormInputElement
              type="tel"
              id="MobileNo"
              ColWidth={6}
              maxLength={100}
              Label="Mobile Number"
              defaultValue={formModal.MobileNo || ""}
              placeholder="Mobile Number"
            />

            <FormInputElement
              type="text"
              id="TelNo"
              ColWidth={6}
              maxLength={12}
              Label="Home Phone"
              defaultValue={formModal.TelNo || ""}
              placeholder="Home Phone"
            />

            <FormInputElement
              type="text"
              id="hns_number"
              ColWidth={6}
              maxLength={15}
              Label="NHS Number"
              defaultValue={formModal.hns_number || ""}
              placeholder="NHS Number"
            />

            <FormInputElement
              type="date"
              id="dateofbirth"
              ColWidth={6}
              Label="Date of Birth"
              defaultValue={formModal.dateofbirth || ""}
              required={true}
            />
            {error && <p className="text-danger fw-bold">{error}</p>}

            <Col xs="6">
              <Form.Group controlId="gender">
                <Form.Label>Gender</Form.Label>
                <Form.Select
                  id="gender"
                  value={formModal.gender || ""}
                  onChange={e => setFormModal({ ...formModal, gender: e.target.value })}
                  required
                >
                  <option value="">Choose...</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="">Prefer not to say</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  Please select a gender.
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs="10">
              <Form.Group>
                <Form.Label>Address</Form.Label>
                <div className="form-control-wrap">
                  <Form.Control
                    id="company_add1"
                    maxLength={150}
                    type="text"
                    defaultValue={formModal.company_add1 || ""}
                    placeholder="Address Line 1"
                    required
                    isInvalid={validated && !modalForm.current?.querySelector('#company_add1')?.value}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter Address Line 1.
                  </Form.Control.Feedback>

                  <Form.Control
                    id="company_add2"
                    maxLength={150}
                    type="text"
                    defaultValue={formModal.company_add2 || ""}
                    placeholder="Address Line 2"
                  />

                  <Form.Control
                    id="company_add3"
                    maxLength={50}
                    type="text"
                    defaultValue={formModal.company_add3 || ""}
                    placeholder="Town/City"
                    required
                    isInvalid={validated && !modalForm.current?.querySelector('#company_add3')?.value}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter Town/City.
                  </Form.Control.Feedback>

                  <Form.Control
                    id="company_add4"
                    maxLength={50}
                    type="text"
                    defaultValue={formModal.company_add4 || ""}
                    placeholder="County"
                    required
                    isInvalid={validated && !modalForm.current?.querySelector('#company_add4')?.value}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter County.
                  </Form.Control.Feedback>

                  <Form.Control
                    id="postcode"
                    maxLength={8}
                    type="text"
                    defaultValue={formModal.postcode || ""}
                    placeholder="Postcode"
                    required
                    isInvalid={validated && !modalForm.current?.querySelector('#postcode')?.value}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter Postcode.
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="danger" onClick={closeFormModal}>
            Discard
          </Button>
          <Button variant="primary" type="submit">
            Update
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default EditClientSection1;
